module.exports = __webpack_public_path__ + "static/media/org_structure.a934961d.png";